import { useNavigate } from "react-router-dom"
import { motion } from "framer-motion"
import { Home, ArrowLeft, AlertCircle } from 'lucide-react'

function NotFoundPage() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen flex items-start mt-14 justify-center bg-white dark:bg-neutral-950 transition-colors duration-300 p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-md"
      >
        <div className="text-center mb-6">
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.5 }}
            className="w-24 h-24 bg-yellow-50 dark:bg-yellow-900/10 rounded-full flex items-center justify-center mx-auto mb-6"
          >
            <AlertCircle size={48} className="text-yellow-500 dark:text-yellow-400" />
          </motion.div>

          <motion.h1
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.5 }}
            className="text-6xl font-[500] text-neutral-800 dark:text-white mb-2"
          >
            404
          </motion.h1>

          <motion.h2
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.5 }}
            className="text-2xl font-[400] text-neutral-800 dark:text-white mb-4"
          >
            Page Not Found
          </motion.h2>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.5 }}
            className="text-neutral-600 dark:text-neutral-400 text-sm"
          >
            The page you are looking for doesn't exist or has been moved.
          </motion.p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.5 }}
          className="flex flex-col sm:flex-row gap-3 mt-8"
        >
          <button
            onClick={() => navigate(-1)}
            className="flex-1 px-4 py-3 border border-neutral-200 dark:bg-neutral-800 rounded-xl bg-white dark:border-neutral-900 dark:bg-neutral-900/30 text-neutral-800 dark:text-neutral-200 hover:bg-neutral-50 dark:hover:bg-neutral-700 transition-colors text-sm font-medium flex items-center justify-center gap-2"
          >
            <ArrowLeft size={16} />
            Go Back
          </button>

          <button
            onClick={() => navigate("/")}
            className="flex-1 px-4 py-3 bg-yellow-500 hover:bg-yellow-600 dark:bg-yellow-500 dark:hover:bg-yellow-700 text-white dark:text-black rounded-xl transition-colors text-sm font-medium flex items-center justify-center gap-2"
          >
            <Home size={16} />
            Home
          </button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8, duration: 0.5 }}
          className="mt-12 p-6 bg-neutral-50 dark:border-neutral-900 dark:bg-neutral-900/50 rounded-xl border border-neutral-200 dark:bg-neutral-800"
        >
          <div className="text-sm text-neutral-600 dark:text-neutral-400">
            <p className="mb-2">Looking for something specific?</p>
            <ul className="space-y-2">
              <li className="flex items-center gap-2">
                <div className="w-1.5 h-1.5 rounded-full bg-yellow-500"></div>
                <a href="/credit-accounts" className="text-yellow-500 dark:text-yellow-400 hover:underline">
                  Credit Accounts
                </a>
              </li>
              <li className="flex items-center gap-2">
                <div className="w-1.5 h-1.5 rounded-full bg-yellow-500"></div>
                <a href="/ad-accounts" className="text-yellow-500 dark:text-yellow-400 hover:underline">
                  Ad Accounts
                </a>
              </li>
              <li className="flex items-center gap-2">
                <div className="w-1.5 h-1.5 rounded-full bg-yellow-500"></div>
                <a href="/settings" className="text-yellow-500 dark:text-yellow-400 hover:underline">
                  Settings
                </a>
              </li>
            </ul>
          </div>
        </motion.div>
      </motion.div>
    </div>
  )
}

export default NotFoundPage
